import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

import { Market } from '../components/Market';
import { OpenPositions } from '../components/OpenPositions';
import { NewPosition } from '../components/NewPosition';
import { CurrentPosition } from '../components/CurrentPosition';
import { MarketHistory } from '../components/MarketHistory';
import useLayout from '../contexts/LayoutContext';
import useMarketsContext from '../contexts/MarketsContext';
import { HydratedPosition } from '../utils/data';
import {
  MultiHeaderContainer,
  HeaderContainer,
  NestedHeaderContainer,
} from '../components/Container';
import { Activity } from '../components/Activity';

const TradeWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  width: 100%;

  @media only screen and (min-width: ${({ theme }) => theme.tablet}) {
    width: 100vw;
    height: calc(100vh - 3.5rem);
  }
`;

const Col = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;

  & > * {
    margin-top: 0.2rem;
  }

  @media only screen and (min-width: ${({ theme }) => theme.tablet}) {
    max-height: calc(100vh - 4rem);
  }
`;

const PositionSection = styled(MultiHeaderContainer)`
  height: auto;
  min-height: 20rem;
`;

const WideCol = styled(Col)`
  display: flex;
  flex-direction: column;
  width: calc(100% - 28.75rem);
`;

const SmallCol = styled(Col)`
  width: 28rem;
`;

export default function Trade() {
  const { isMobile, isTablet } = useLayout();
  const { selectedMarket } = useMarketsContext();
  const { t } = useTranslation();

  return (
    <TradeWrapper>
      {!isMobile && !isTablet ? (
        <>
          <WideCol>
            <Market />
            <PositionSection
              options={[
                {
                  title: `${selectedMarket?.name} ${t('position')}`,
                  component: <CurrentPosition />,
                },
                {
                  title: t('Activity'),
                  component: <Activity />,
                  scrollable: true,
                },
                {
                  title: t('All positions'),
                  component: (
                    <OpenPositions filter={(position: HydratedPosition) => !position.closed} />
                  ),
                  scrollable: true,
                },
              ]}
            />
          </WideCol>
          <SmallCol>
            <NewPosition />
            <HeaderContainer title={t('Market history')} scrollable>
              <MarketHistory />
            </HeaderContainer>
          </SmallCol>
        </>
      ) : (
        <Col>
          <Market />
          <MultiHeaderContainer
            options={[
              {
                title: t('Trade'),
                component: <NewPosition />,
              },
              {
                title: t('Position'),
                component: (
                  <NestedHeaderContainer
                    options={[
                      {
                        title: `${selectedMarket?.name} ${t('position')}`,
                        component: <CurrentPosition />,
                      },
                      {
                        title: t('Activity'),
                        component: <Activity />,
                      },
                      {
                        title: t('All positions'),
                        component: (
                          <OpenPositions
                            filter={(position: HydratedPosition) => !position.closed}
                          />
                        ),
                      },
                    ]}
                  />
                ),
                scrollable: true,
              },
              {
                title: t('Market history'),
                component: <MarketHistory />,
                scrollable: true,
              },
            ]}
          />
        </Col>
      )}
    </TradeWrapper>
  );
}
